export default __webpack_public_path__ + "static/media/pic4.56ecd844.jpg";